<template>
  <div
    v-if="feature.text || isEditMode"
    :class="{
      'price-list-item-feature-fi': true,
      'price-list-item-feature-fi--light': light,
      'price-list-item-feature-fi--checked': feature.checked,
    }"
  >
    <icon-fi
      class="price-list-item-feature-fi__icon"
      :icon="feature.checked ? 'check' : 'close'"
      size="1"
    />
    <span v-if="!isEditMode">{{ feature.text }}</span>
    <!-- eslint-disable vue/no-v-html -->
    <span
      v-else
      v-html="feature.editable"
    />
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>

<script>
import { IconFi } from 'atoms';

export default {
  name: 'PriceListItemFeatureFi',
  components: {
    IconFi,
  },
  props: {
    feature: {
      type: Object,
      default: () => ({}),
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
@import './price-list-item-feature-fi';
</style>
